(function () {
  'use strict';

  var cfg = window.joyeSnow;
  if (!cfg || !cfg.enabled) return;

  var MOBILE_BP = 768;
  var isMobile = window.innerWidth < MOBILE_BP;
  if (isMobile && !cfg.mobile) return;

  function hex(h) {
    h = String(h || '#ffffff').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function rgba(h, a) {
    var c = hex(h);
    return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')';
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  var COOL = '#7b88a6';

  var color  = cfg.color || '#ffffff';
  var op     = (cfg.opacity == null ? 75 : cfg.opacity) / 100;
  var halo   = (cfg.halo == null ? 60 : cfg.halo) / 100;
  var speedK = (cfg.speed == null ? 95 : cfg.speed) / 100;
  var count  = cfg.density == null ? 240 : cfg.density;
  if (isMobile) count = Math.round(count * 0.45);

  /* ---------- canvas ---------- */
  var cv = document.createElement('canvas');
  cv.className = 'joye-snow';
  cv.setAttribute('aria-hidden', 'true');
  cv.style.cssText =
    'position:fixed;inset:0;top:0;left:0;width:100%;height:100%;' +
    'pointer-events:none;z-index:' + (cfg.zIndex || 55) + ';';
  document.body.appendChild(cv);

  var ctx = cv.getContext('2d');
  var W = 0, H = 0;
  var parts = [];

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;
    cv.width = Math.floor(W * dpr);
    cv.height = Math.floor(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function makeP() {
    var d = Math.random();
    return {
      x: Math.random() * W,
      y: Math.random() * H,
      d: d,
      r: rnd(1, 3.4) * 1.1,
      a: rnd(0.45, 1),
      vy: rnd(70, 165) * (0.5 + d),
      ph: Math.random() * 6.28,
      sa: rnd(0.3, 1.4),
      ss: rnd(0.4, 1.4),
      tw: Math.random() * 6.28,
      star: Math.random() < 0.13,
      rot: Math.random() * 6.28,
      sp: rnd(-0.9, 0.9)
    };
  }
  function seed() {
    parts = [];
    for (var i = 0; i < count; i++) parts.push(makeP());
  }

  function step(dt) {
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      p.y += p.vy * speedK * dt;
      p.ph += p.ss * dt;
      p.x += (16 * (0.35 + p.d) + Math.sin(p.ph) * p.sa * 18) * dt;
      p.rot += p.sp * dt;
      p.tw += dt * 4;

      if (p.y - p.r > H) { p.y = -p.r; p.x = Math.random() * W; }
      if (p.x - p.r > W) p.x = -p.r;
      else if (p.x + p.r < 0) p.x = W + p.r;
    }
  }

  function draw() {
    var GLOW = halo > 0 ? rgba(COOL, 0.75 * halo) : rgba(color, 0.9 * op);
    ctx.clearRect(0, 0, W, H);
    ctx.save();

    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      ctx.globalAlpha = p.a * op * (0.35 + 0.65 * (0.5 + 0.5 * Math.sin(p.tw)));
      ctx.fillStyle = color;
      ctx.shadowColor = GLOW;
      ctx.shadowBlur = 4 + 5 * halo;
      if (p.star) {
        var s = p.r * 3.2;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * 0.4);
        ctx.beginPath();
        ctx.moveTo(0, -s); ctx.lineTo(p.r * 0.5, -p.r * 0.5);
        ctx.lineTo(s, 0);  ctx.lineTo(p.r * 0.5, p.r * 0.5);
        ctx.lineTo(0, s);  ctx.lineTo(-p.r * 0.5, p.r * 0.5);
        ctx.lineTo(-s, 0); ctx.lineTo(-p.r * 0.5, -p.r * 0.5);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      } else {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, 6.284);
        ctx.fill();
      }
      ctx.shadowBlur = 0;
    }

    ctx.restore();
  }

  var last = performance.now(), raf = 0;

  function frame(now) {
    var dt = Math.min((now - last) / 1000, 0.05);
    last = now;
    step(dt);
    draw();
    raf = requestAnimationFrame(frame);
  }
  function start() {
    if (raf) return;
    last = performance.now();
    raf = requestAnimationFrame(frame);
  }
  function stop() {
    if (!raf) return;
    cancelAnimationFrame(raf);
    raf = 0;
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { resize(); seed(); }, 150);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  resize();
  seed();
  start();
})();
